import React from 'react';
import { FlameIcon } from 'lucide-react';
interface ScarcityBarProps {
  spotsLeft?: number;
  total?: number;
  tone?: 'light' | 'dark';
}
export function ScarcityBar({
  spotsLeft = 12,
  total = 300,
  tone = 'light'
}: ScarcityBarProps) {
  const claimed = total - spotsLeft;
  const percent = Math.round(claimed / total * 100);
  const isDark = tone === 'dark';
  return <div className={`mx-auto w-full max-w-md rounded-2xl px-4 py-3.5 ${isDark ? 'bg-white/10 ring-1 ring-white/15' : 'bg-white ring-1 ring-navy-800/10 shadow-card'}`} data-id="element-55" data-mp="2b6qdugvgs0me">
      <div className="flex items-center justify-between gap-2" data-id="element-56" data-mp="2g3gvh8mx349x">
        <p className={`flex items-center gap-1.5 text-[12px] font-extrabold uppercase tracking-wide ${isDark ? 'text-aqua-200' : 'text-navy-800'}`} data-id="element-57" data-mp="227mtl9kk9f6b">
          <FlameIcon className="h-4 w-4 text-orange-500" aria-hidden="true" data-id="element-58" data-mp="g0adu6wuoke" />
          Only {spotsLeft} spots left
        </p>
        <p className={`text-[12px] font-bold tabular-nums ${isDark ? 'text-white/70' : 'text-navy-800/60'}`} data-id="element-59" data-mp="5bpco5abejke">
          {percent}%
        </p>
      </div>

      <div className={`mt-2.5 h-3 w-full overflow-hidden rounded-full ${isDark ? 'bg-white/15' : 'bg-navy-800/10'}`} role="progressbar" aria-valuenow={percent} aria-valuemin={0} aria-valuemax={100} aria-label={`${claimed} of ${total} promotional spots claimed`} data-id="element-60" data-mp="2zk8c0a2pna4b">
        <div className="h-full rounded-full bg-orange-500 transition-[width] duration-300 ease-out" style={{
        width: `${percent}%`
      }} data-id="element-61" data-mp="2koixewzutz9m" />
      </div>

      <p className={`mt-2 text-[11.5px] leading-snug ${isDark ? 'text-white/65' : 'text-navy-800/60'}`} data-id="element-62" data-mp="2umgixcqbxhyj">
        {claimed} of {total} promotional spots at <strong className={isDark ? 'text-white' : 'text-navy-800'} data-id="element-63" data-mp="2pp6nngg9ec2s">$27</strong> have already been claimed.
      </p>
    </div>;
}